import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("iona_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getBlogs = () => apiClient.get("/blogs").then((r) => r.data);
export const getBlogBySlug = (slug) =>
  apiClient.get(`/blogs/${slug}`).then((r) => r.data);

export const adminLogin = (email, password) =>
  apiClient.post("/admin/login", { email, password }).then((r) => r.data);
export const adminMe = () => apiClient.get("/admin/me").then((r) => r.data);
export const adminListBlogs = () =>
  apiClient.get("/admin/blogs").then((r) => r.data);
export const adminCreateBlog = (payload) =>
  apiClient.post("/admin/blogs", payload).then((r) => r.data);
export const adminUpdateBlog = (id, payload) =>
  apiClient.put(`/admin/blogs/${id}`, payload).then((r) => r.data);
export const adminDeleteBlog = (id) =>
  apiClient.delete(`/admin/blogs/${id}`).then((r) => r.data);
export const adminGenerateBlog = (topic, category) =>
  apiClient
    .post("/admin/generate-blog", { topic, category })
    .then((r) => r.data);
